import React, {
    useState,
    useEffect,
 
} from "react"
import { Checkbox } from './ot'

const BaseListView1_1 = ({
     checked,
    onCheckedChange = () => { }
}, ref) => {
    

    return (
        <div >
                    <Checkbox
                        checked={checked}
                        onCheckedChange={onCheckedChange}
                    />
                </div>
    )
}

export default BaseListView1_1
